import React,{useState, useEffect} from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { api, eventURL, WorkshopListURL } from "../../../apis/urls";
import Loader from "../../../common-components/loader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";
import { Table, Toggle,Pagination } from "rsuite";
import { Fragment } from "react-read-more-read-less";

const { Column, HeaderCell, Cell } = Table;

const WorkshopMultiple = () => {

    const [added, setAdded] = useState(false);
    const [publish, setPublish] = useState('');

    const [pageno, setPageno] = useState(0);

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Listing();
            });
    }, []);

    const [loader,setLoader] = useState(true);
    const [result,setResult] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [alertText, setAlertText]=useState("");
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);
    const [emptyItem, setEmptyItem] = useState(false);

    const [sessionName,setSessionName] = useState('');


    let counts = 0;
    if(result)
    {
        counts = result.length;
    }

    const {wid, sid} = useParams();

    let navigate = useNavigate();





    const Listing = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: WorkshopListURL+"/multiple/"+wid+"/"+sid+'?page='+pageno+'&size='+10,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{

            setSessionName(response.data.sessionName)


            if(response.data.message === "Success"){            
                console.log("current page ===>", response.data.data);
                setResult(response.data.data.sort((a, b) => b.createdAt.localeCompare(a.createdAt)));
                setCurrentpage(response.data.currentPage)
                setTotalPages(response.data.totalPages)
                setTotalItems(response.data.totalItems)
                setLoader(false)
                }else{
                setResult(false);
                setLoader(false);
            }

           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }




        let token = "Bearer "+localStorage.getItem('token');
        const instances = axios.create({
            baseURL: WorkshopListURL,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        const findByTitles = name => {
            return instances.get(`/multiple/`+wid+`/`+sid+`?search=${name}`);
        };

        const onChangeSearchTitle = (e) => {
            const searchTitle = e.target.value;
            setSearchTitle(searchTitle);
            findByTitles(searchTitle)
            .then(response => {
                if(response.data.message=== "Success"){
                    setResult(response.data.data)
                    setCurrentpage(response.data.currentPage)
                    setTotalPages(response.data.totalPages)
                    setTotalItems(response.data.totalItems)
                }else{
                    setResult(false)
                }
            })
            .catch(e => {
                console.log(e);
            });
        };


    //PAGINATION


    const handlePageClick = (event) => { console.log('EVENTSSS',event)

     $('html,body').animate({ scrollTop: 0 }, 'fast');

        
     const instance = axios.create({
         baseURL: WorkshopListURL+"/multiple/"+wid+"/"+sid+`?search=`+searchTitle+'&page='+event.selected+'&size='+10,
         timeout: 1000000,
         headers: {'authorization': token}
       });

       

     instance.get('').then(res => {

        setResult(res.data.data);
        setCurrentpage(res.data.currentPage)
        setTotalPages(res.data.totalPages)
        setTotalItems(res.data.totalItems)

    //  console.log('paginatansresss',res.data.data.items)
     
         setLoader(false);
     }).catch(e => {
     console.log('errorshw',e);
     });

    };

   


    let sl =1;
    return (
        <div className="wrapper">
            <aside className="right-side ">
                <div class="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            <i className="icon-suitcase1"></i>
                            <h2 className="page-title">Workshops - {sessionName}</h2>
                        </div>

                        <div class="page-rightside-action-column">
                    <div class="input-groups mt-3 mb-3 search-grps">
                        <input type="text" 
                        class="form-controls search-bar asso-search"             
                        value={searchTitle}
                        onChange={onChangeSearchTitle}
                        placeholder="Search" />
                        <button  class="btn btn-search icon-search assosearch-btn"></button>
                        </div>
                        <Link to={"/workshop/session/add/"+wid+"/"+sid} data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New School"><i class="icon-add"></i><span>Add New Workshop</span> </Link>

                    </div>
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/workshop">Conference Manager</Link></li>
                            
                            <li className="breadcrumb-item active" aria-current="page"><Link to={"/sessions/"+wid}>Sessions</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Workshop</li>

                        </ol>
				    </nav>

                        {result?
                        (<div class="number-of">
                        Displaying {(currentpage*10 )+ 1}-{(currentpage*10 )+ counts} of {totalItems} results.
                        </div>):null
                        }


                    <div className="jobs-list-wrpr list-wrpr" >

                        {result?(
                        result?.map((item,index) =>
                            (
   
                                <>


                                <div className="list">
                                    <div className="row">
                                        <div className="col-md-1">
                                        <div class="jobs-user">
                                        <span class="desig">Sl.No</span>
                                        {(index+1)+currentpage*10}
                                        </div>
                                        </div>
                                        
                                        <div className="col-md-3">
                                            <div className="jobs-user" style={{lineBreak:'anywhere'}}>
                                            <span class="desig">Workshop Topic</span>

                                            {decode(item.topic)}
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="jobs-user">
                                            <span class="desig">Presenter Name</span>
                                                 {item.presenter_name}
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="jobs-user">
                                            <span class="desig">Maximum Seats</span>
                                                 {item.max_seats}
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="jobs-user">
                                            <span class="desig">Presenter Title</span>
                                                 {item.presenter_title}
                                            </div>
                                        </div>

                                    
                                        <div className="col-md-2">
                                            <div className="list-action-wrpr text-right  roundicons-text event-btns">
                                            <button button onClick={()=>{navigate("/workshop/attendees/view/"+item.topic+'/'+wid+"/"+sid+"/"+item.id)}} style={{backgroundColor:'transparent' }}  data-toggle="tooltip" title="Attendees" ><a><i className="delete icon-user2 data-counts-icon" data-count={item.attendees_count} style={{background:'#0068FF'}}></i><span>Attendees</span></a></button>
                                                <button onClick={()=>{navigate("/workshop/session/view/"+wid+"/"+sid+"/"+item.id)}} style={{backgroundColor:'transparent' , marginLeft:'20px' }}  data-toggle="tooltip" title="View" ><a><i className="delete icon-eye" style={{background:'#ff577f'}}></i><span>View</span></a></button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </>
                           
                           
                           
                           )

                        )):null
                        }
                        {
                            !result?
                            <div>
                                {searchTitle.length ===0?
                                    <div className="nodata empty-workshop">

                                         <Link to={"/workshop/session/add/"+wid+"/"+sid} data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New School"><i class="icon-add"></i><span>Add New Workshop</span> </Link>
                                
                                    </div>:
                                    <div className="nodata">

                                            <h2>Sorry! No Result Found</h2>
                                
                                    </div>
                                }
                            </div>:null
                        }
                        {result?

                        (<div class="number-of footer-number">
                            Displaying {(currentpage*10 )+ 1}-{(currentpage*10 )+ counts} of {totalItems} results.
                        </div>):null
                        }
    
                    </div>

                    { 
                        loader?
                        <div>
                            <div className="loader_container"><Loader/></div>
                        </div>
                        :
                        null
                    }



                {result?
                    <div class="pagination-wrpr">
                        <ReactPaginate
                                className="pagination page"
                                pageClassName="page-item"
                                activeClassName="active"
                                nextLabel=">"
                                previousLabel="<"
                                previousClassName="page-link p-link"
                                nextClassName="page-link p-link"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={10}
                                pageCount={totalPages}
                                renderOnZeroPageCount={1}
                            />
                    </div>:null}



                </div>
            </aside>
        </div>
    )
}

export default WorkshopMultiple;